/**
 * ConnectionIndicator - Shows real-time connection status
 * Displays a small indicator in the UI to show SSE connection state
 */

import { useRealtime, ConnectionState } from '../context/RealtimeContext'

function ConnectionIndicator() {
  const { connectionState, reconnect, isConnected, isConnecting, hasError } = useRealtime()

  // Don't show anything when connected (minimal UI)
  if (isConnected) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {isConnecting && (
        <div className="bg-yellow-500/90 text-yellow-900 px-4 py-2 text-sm text-center flex items-center justify-center gap-2">
          <span className="animate-spin inline-block w-4 h-4 border-2 border-yellow-900 border-t-transparent rounded-full" />
          Connecting to real-time updates...
        </div>
      )}

      {hasError && (
        <div className="bg-red-500/90 text-white px-4 py-2 text-sm text-center flex items-center justify-center gap-2">
          <span className="text-lg">⚠</span>
          Real-time connection failed.
          <button
            onClick={reconnect}
            className="underline hover:no-underline ml-2"
          >
            Retry
          </button>
        </div>
      )}

      {connectionState === ConnectionState.DISCONNECTED && (
        <div className="bg-gray-600/90 text-white px-4 py-2 text-sm text-center flex items-center justify-center gap-2">
          <span className="inline-block w-2 h-2 bg-gray-400 rounded-full" />
          Offline - Updates paused
        </div>
      )}
    </div>
  )
}

export default ConnectionIndicator
